import api from './api';
import { ProduitService } from '../types';

export const produitServiceService = {
  getAll: () => api.get<ProduitService[]>('/api/produits').then((r) => r.data),
  getById: (id: number) => api.get<ProduitService>(`/api/produits/${id}`).then((r) => r.data),
  create: (data: Partial<ProduitService>) => api.post<ProduitService>('/api/produits', data).then((r) => r.data),
  update: (id: number, data: Partial<ProduitService>) =>
    api.put<ProduitService>(`/api/produits/${id}`, data).then((r) => r.data),
  delete: (id: number) => api.delete(`/api/produits/${id}`),
};
